export default "__VITE_ASSET__BztsDnHn__"